import { z } from 'zod';
import { projectCreationSchema } from '../newProject/validation';

export const projectEditSchema = projectCreationSchema.pick({
    description: true,
    commercialIds: true,
});

export const projectEmailsSchema = projectCreationSchema.pick({
    emailFrom: true,
    nameFrom: true,
});

export const bindCustomerSchema = z.object({
    customerId: z
        .string("Seleziona il cliente")
        .min(1, 'Il cliente è obbligatorio')
        .regex(/^[0-9a-fA-F]{24}$/, 'ID cliente non valido')
        .nullable()
        .optional(),
});

export type ProjectEditFormData = z.infer<typeof projectEditSchema>;
export type ProjectEmailsFormData = z.infer<typeof projectEmailsSchema>;
export type BindCustomerFormData = z.infer<typeof bindCustomerSchema>;
